/**
 * Asset status values used throughout the Chariot platform.
 *
 * Status Lifecycle:
 * - Active ('A'): Asset is currently being monitored and scanned
 * - Inactive ('I'): Asset monitoring is paused
 * - Deleted ('D'): Asset has been removed from the system
 *
 * Used in API calls to maintain asset state when updating other fields
 * (e.g., when modifying tags, we must preserve the current status).
 */
export const AssetStatus = {
  Active: 'A',
  Inactive: 'I',
  Deleted: 'D',
  Unavailable: 'U',
} as const;

export type AssetStatusValue = (typeof AssetStatus)[keyof typeof AssetStatus];

/**
 * Default status for assets when status is unknown or missing.
 *
 * Active status ensures the asset remains in the monitoring system.
 * This fallback is used when:
 * - Asset data doesn't include status field
 * - Creating new asset entries
 * - Status needs to be preserved but isn't available
 */
export const DEFAULT_ASSET_STATUS = AssetStatus.Active;
